import { CommonModule } from '@angular/common';
import { Component, inject, input, signal } from '@angular/core';
import { combineLatest, debounceTime, filter,  map, switchMap, tap } from 'rxjs';
import { ErrorLogService } from 'app/services/error-log/error-log.service';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { UserService } from 'app/services/user/user.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { toObservable } from '@angular/core/rxjs-interop';
import { CacheService } from 'app/services/cache-service/cache.service';

@Component({
  selector: 'app-error-category-cards',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './error-category-cards.component.html',
  styleUrl: './error-category-cards.component.scss'
})
export class ErrorCategoryCardsComponent {

  public readonly errorLogService = inject(ErrorLogService);
  public readonly cacheService = inject(CacheService);

  public readonly districtIds = input.required<string[]>();
  public readonly schoolIds = input.required<string[]>();
  public readonly year = input.required<number>();

  public isLoading = signal<boolean>(false);

  public readonly viewModel$ = combineLatest([
      toObservable(this.districtIds),
      toObservable(this.schoolIds),
      toObservable(this.year)
  ]).pipe(
    map(([districtIds, schoolIds, year]) => ({districtIds, schoolIds, year})),
    tap(() => this.isLoading.set(true)),
    switchMap(_ => this.errorLogService.getCounts(_.districtIds, _.schoolIds, this.cacheService.selectedSchoolYear())
      .pipe(
        map(data => ({
          errorCounts: data
        }))
      )),
    tap(() => this.isLoading.set(false)),
  );
}
